
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    name: String,
    icone: String,
    idcon: String,
    userName: String,
    cardNumber: String,
    cardExpiring: String,
    typeCard: String,
    cardFlag: String,
    id: Number,
    toDo: Function,
    isMainCard: Boolean,
    onChange: Function,
  },
  components: {},
})
export default class OptionCollapseParent extends Vue {
  mounted() {
    var elems = document.querySelectorAll(".collapsible");
    var instances = M.Collapsible.init(elems, {});
  }
}
